import { defineMessages } from 'react-intl';

export const messages: {
	modalTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	modalSubheading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	done: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noResults: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	modalTitle: {
		id: 'bulk-connect-dialog-title',
		defaultMessage: 'Connect your apps',
		description:
			'Heading text displayed at the top of the bulk connect modal dialog where users can connect their third-party apps.',
	},
	modalSubheading: {
		id: 'bulk-connect-dialog-subheading',
		defaultMessage: 'Find missing results by connecting the apps you use in your work',
		description:
			'Subheading text shown below the title in the bulk connect modal dialog, explaining the purpose of connecting apps to improve search results.',
	},
	cancel: {
		id: 'bulk-connect-cancel',
		defaultMessage: 'Cancel',
		description: 'Cancel button for the bulk connect dialog',
	},
	done: {
		id: 'bulk-connect-done',
		defaultMessage: 'Done',
		description:
			'Label for the Done button in the bulk connect modal dialog, which closes the dialog after the user has finished connecting apps.',
	},
	searchIconLabel: {
		id: 'search-icon-label',
		defaultMessage: 'Search',
		description:
			'Accessible label for the search icon inside the bulk connect dialog search input field.',
	},
	searchPlaceholder: {
		id: 'search-icon-placeholder',
		defaultMessage: 'Search',
		description:
			'Placeholder text shown inside the search input field in the bulk connect dialog, prompting users to search for apps to connect.',
	},
	noResults: {
		id: 'bulk-connect-no-results',
		defaultMessage: "We couldn't find apps matching your search",
		description:
			"Message displayed in the bulk connect dialog when no apps match the user's search query.",
	},
});
